import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    # TOAST
\*------------------------------------ */
:host {
  --cat-toast-active-position: 2rem;
}

/**
 * Toast
 * 1) Message of information, success, error, or warning to the user
 */
.cat-c-toast {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: var(--cat-theme-color-content-strong);
  border-style: solid;
  border-width: var(--cat-border-width-sm);
  border-inline-start-width: var(--cat-border-width-lg);
  border-color: var(--cat-theme-color-border-utility-information);
  background-color: var(--cat-theme-color-background-utility-information);
  box-shadow: var(--cat-box-shadow-lg);
  padding-block: calc(var(--size-base-unit) * 1.875);
  padding-inline: var(--cat-space-medium);
  animation-name: slideTopPosition;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  position: relative;
  min-width: calc(var(--size-base-unit) * 37.5);
  max-width: 100%;
  width: max-content;
}
@media all and (width <= calc(23.4375rem - 0.02px)) {
  .cat-c-toast {
    min-width: auto;
  }
}

/**
 * Dismiss toast top
 */
.cat-has-animation {
  animation-name: slideTopPositionDismiss;
}

/**
 * Animate in toast bottom
 */
.cat-c-toast--bottom {
  animation-name: slideBottomPosition;
}

/**
 * Dismiss toast bottom
 */
.cat-c-toast--bottom.cat-has-animation {
  animation-name: slideBottomPositionDismiss;
}

/**
 * Close button
 */
.cat-c-toast__close-button {
  position: absolute;
  inset-block-start: var(--cat-toast-close-icon-start, var(--cat-space-small));
  inset-inline-end: var(--cat-toast-close-icon-end, var(--cat-space-medium));
  --cat-button-padding: var(--cat-space-2x-small);
}

/**
 * Toast with close button
 */
.cat-is-dismissible {
  padding-inline-end: var(--cat-space-4x-large);
}

/**
 * Slide into position top
 */
@keyframes slideTopPosition {
  from {
    opacity: 0;
    inset-block-start: -100%;
  }
  to {
    opacity: 1;
    inset-block-start: var(--cat-toast-active-position);
  }
}
/**
 * Slide away top
 */
@keyframes slideTopPositionDismiss {
  from {
    opacity: 1;
    inset-block-start: var(--cat-toast-active-position);
  }
  to {
    opacity: 0;
    inset-block-start: -100%;
  }
}
/**
 * Slide into position bottom
 */
@keyframes slideBottomPosition {
  from {
    opacity: 0;
    inset-block-end: -100%;
  }
  to {
    opacity: 1;
    inset-block-end: var(--cat-toast-active-position);
  }
}
/**
 * Slide away bottom
 */
@keyframes slideBottomPositionDismiss {
  from {
    opacity: 1;
    inset-block-end: var(--cat-toast-active-position);
  }
  to {
    opacity: 0;
    inset-block-end: -100%;
  }
}
/**
 * Toast success
 */
.cat-c-toast--success {
  border-color: var(--cat-theme-color-border-utility-success);
  background-color: var(--cat-theme-color-background-utility-success);
}

/**
 * Toast warning
 */
.cat-c-toast--warning {
  border-color: var(--cat-theme-color-border-utility-warning);
  background-color: var(--cat-theme-color-background-utility-warning);
}

/**
 * Toast error
 */
.cat-c-toast--error {
  border-color: var(--cat-theme-color-border-utility-error);
  background-color: var(--cat-theme-color-background-utility-error);
}

/**
 * Toast icon
 */
.cat-c-toast__icon {
  display: flex;
  align-items: center;
  position: relative;
  margin-inline-end: var(--cat-space-x-small);
  --cat-icon-fill: var(--cat-theme-color-content-utility-information);
  /**
   * Toast icon within success toast
   */
  /**
   * Toast icon within warning toast
   */
  /**
   * Toast icon error
   */
}
.cat-c-toast--success .cat-c-toast__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-success);
}
.cat-c-toast--warning .cat-c-toast__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-warning);
}
.cat-c-toast--error .cat-c-toast__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-error);
}

/**
 * Toast body
 * 1) Allows the body to take up the remaining space that the icon doesn't occupy
 */
.cat-c-toast__body {
  flex: 1;
}

.cat-c-toast:not(.cat-c-toast--has-before) .cat-c-toast__icon {
  display: none;
}
`;
       